import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Zap, Gift } from 'lucide-react';
export function PriceComparison() {
  return <section className="py-16 lg:py-20 bg-[#0E3B26] text-white relative overflow-hidden" data-id="element-192">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-194">
          <h2 className="text-2xl md:text-4xl font-[800] mb-3" data-id="element-195">
            La cuenta es simple 🧮
          </h2>
          <p className="text-base md:text-lg text-green-100 font-[600]" data-id="element-196">
            Mirá cuánto te ahorrás eligiendo nuestro pack
          </p>
        </motion.div>

        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4 sm:gap-2 mb-10" data-id="element-197">
          {/* Comprando paquetes */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-[#0A2C1C] rounded-2xl p-6 text-center border border-white/10 flex flex-col justify-center" data-id="element-198">
            <p className="text-xs sm:text-sm font-[800] uppercase tracking-widest text-green-200 mb-3" data-id="element-199">
              Comprando Paquetes
            </p>
            <p className="text-4xl sm:text-5xl font-display line-through decoration-2 mb-3 font-[900] text-[#E80A1D]" data-id="element-200">
              $430.000
            </p>
            <p className="text-sm text-green-100" data-id="element-201">
              Esto te sale llenar el álbum, sin contar las repetidas
            </p>
          </motion.div>

          {/* Arrow */}
          <div className="flex items-center justify-center sm:px-2 font-[700]" data-id="element-202">
            <div className="bg-wc-blue rounded-full p-2 rotate-90 sm:rotate-0" data-id="element-203">
              <ArrowRight className="w-6 h-6 text-white" data-id="element-204" />
            </div>
          </div>

          {/* Con nuestro pack */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-wc-yellow rounded-2xl p-6 text-center text-wc-dark flex flex-col justify-center shadow-2xl" data-id="element-205">
            <p className="text-xs sm:text-sm font-[800] uppercase tracking-widest mb-3" data-id="element-206">
              Con Nuestro Pack
            </p>
            <p className="text-4xl sm:text-5xl font-display mb-3 font-[900]" data-id="element-207">
              $15.990
            </p>
            <p className="text-sm font-[600]" data-id="element-208">
              Todas las figuritas + álbum de regalo · acceso inmediato
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center font-[800]" data-id="element-209">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-6 text-sm text-green-100" data-id="element-210">
            <div className="flex items-center gap-1.5" data-id="element-211">
              <Lock className="w-4 h-4 text-wc-yellow" data-id="element-212" />
              <span data-id="element-213">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-214">
              <Zap className="w-4 h-4 text-wc-yellow" data-id="element-215" />
              <span data-id="element-216">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-217">
              <Gift className="w-4 h-4 text-wc-yellow" data-id="element-218" />
              <span data-id="element-219">Álbum de regalo incluido</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}